module.exports = __webpack_public_path__ + "assets/img/b.0e837226.png";